import { actions as organizationActions } from '@saucelabs/sl-module-organization';
import { PAGINATION_LIMIT } from '@saucelabs/sl-util-config';

import * as actions from './actions';
import { actions as activityActions, utils as activityUtils } from './../activity';
import { CHARTS_DATA_PERIOD, CHARTS_NUMBER_OF_PERIODS } from './../activity/constants';
import { utils as tmUtils } from './../team-management';
import { actions as filtersActions } from './../filters';
import { actions as teamsActions } from './../teams';
import { operations as usersOperations } from './../users';
import { actions as entitlementsActions } from './../entitlements';
import { actions as ssoActions } from './../sso';

export const getInitialData = ({ userId, organizationId }) => (dispatch) => {
  dispatch(actions.getInitialDataRequest());

  return Promise.all([
    dispatch(activityActions.getOrganizationActivity({
      orgId: organizationId,
      since: activityUtils.xDaysAgo(CHARTS_DATA_PERIOD * CHARTS_NUMBER_OF_PERIODS + 1),
    })),
    dispatch(teamsActions.getTeamList()),
    dispatch(organizationActions.getOrganization({ organizationId })),
    dispatch(entitlementsActions.getOrgEntitlements({ uuid: organizationId })),
    // we don't want to break if there is no SSO config
    dispatch(ssoActions.getSsoMetadata({ id: userId })).catch((error) => error),
    dispatch(ssoActions.getConfig({ orgUuid: organizationId })).catch((error) => error),
    dispatch(ssoActions.checkAvailable({ orgUuid: organizationId })).catch((error) => error),
  ]).then(
    () => dispatch(actions.getInitialDataSuccess()),
    (error) => dispatch(actions.getInitialDataFailure(error, { skipErrorPage: true })),
  );
};

export const getInitialUserTable = (payload) => (dispatch, getState) => {
  dispatch(actions.getInitialUserTableRequest());
  const currentPage = getState().apps.teamManagement.users.getIn(['users', 'currentPage']);
  const allFilters = tmUtils.serializeFilters(getState().apps.teamManagement.users.get('selectedFilters'));
  const offset = (currentPage - 1) * PAGINATION_LIMIT;
  return Promise.all([
    dispatch(filtersActions.getFilters(payload)),
    dispatch(usersOperations.getAllUserListData({ offset, allFilters })),
    dispatch(teamsActions.getTeamList()),
  ])
    .then(() => {
      dispatch(actions.getInitialUserTableSuccess());
    })
    .catch((error) => {
      dispatch(actions.getInitialUserTableFailure(error));
      throw error;
    });
};
